import { requestWithToken } from '../utilities/request';
import SessionStorageService from './utilities/SessionStorageService';
import authProvider, { needTokenUpdate } from '../utilities/authProvider';
import { API } from '../utilities/constants';

const path = '/api/private/fields/';

const list = (field_id, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`${field_id}/ky_reports/list`),
    params,
  });
};

const detail = (field_id, id) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`${field_id}/ky_reports/${id}`),
  });
};

const updateStatus = (field_id, id, params) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`${field_id}/ky_reports/${id}/update_status`),
    params,
  });
};

const bulkUpdateStatus = (field_id, params) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`${field_id}/ky_reports/bulk_update_status`),
    data: params,
  });
};

const downloadTemplate = async field_id => {
  let token = SessionStorageService.getToken();
  if (needTokenUpdate(token)) {
    token = await authProvider.instance.silentTokenUdate();
  }
  const apiPath = `api/private/fields/${field_id}/ky_reports/download_template.xlsx?excel_token=${token}`;
  window.location.href = `${API.endpoint}/${apiPath}`;
};

const exportReportCr139 = params => {
  return requestWithToken(
    {
      method: 'POST',
      url: '/api/private/reports/cr139_genchi_ky_report',
      data: params,
    },
    false
  );
};

export const KYReportsService = {
  list,
  detail,
  updateStatus,
  bulkUpdateStatus,
  downloadTemplate,
  exportReportCr139,
};

export default KYReportsService;



// WEBPACK FOOTER //
// ./src/services/KYReportsService.js